//
//
//
//
//
//
//
//
//
//

export default {
  name: "SearchResultCount",
	props: {
		results: Object,
		currentResultsStart: Number,
		currentResultsEnd: Number,
	},
	methods: {},
};
